export enum LazoView {
  LAZO_ONE = "/one",
  LAZO_PORTAL = "/portal",
}

interface LazoViewContextType {
  lazoView: LazoView;
  isPortal: boolean;
}

export const useLazoView = (): LazoViewContextType => {
  const isPortal = location.pathname.includes(LazoView.LAZO_PORTAL);
  const lazoView = location.pathname.includes(LazoView.LAZO_ONE) ? LazoView.LAZO_ONE : LazoView.LAZO_PORTAL;
  return { lazoView, isPortal };
};
